import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-black text-lg" }, "이미지 변환", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500 ml-2" }, " *이미지 변환 결과물의 최대 해상도는 FHD 입니다. ", -1)
const _hoisted_3 = { class: "flex gap-4 mt-10" }
const _hoisted_4 = { class: "flex flex-col gap-4 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadCard = _resolveComponent("UploadCard")!
  const _component_FaceMappingCard = _resolveComponent("FaceMappingCard")!
  const _component_ScenarioCard = _resolveComponent("ScenarioCard")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_UploadCard, {
        class: "flex-1",
        onUpload: _ctx.onUpload
      }, null, 8, ["onUpload"]),
      _createVNode(_component_FaceMappingCard, {
        ref: "faceMapRef",
        style: {"flex":"2"},
        "target-face-url": _ctx.targetFaceUrl,
        "face-list": _ctx.fileList
      }, null, 8, ["target-face-url", "face-list"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_ScenarioCard, {
        ref: "scenarioRef",
        disabled: _ctx.fileList.length === 0,
        onClick: _ctx.onClick
      }, null, 8, ["disabled", "onClick"]),
      _createVNode(_component_Table, {
        list: _ctx.state.imageRows,
        total: _ctx.state.imageTotal,
        "is-download": ""
      }, null, 8, ["list", "total"])
    ])
  ]))
}